module.exports = __webpack_public_path__ + "img/home-marketcard-cover.504261b7.png";